<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
  >
    <g id="surface1">
      <path
        style=" stroke:none;fill-rule:nonzero;fill:rgb(87, 91, 108);fill-opacity:1;"
        d="M 17.058594 1.667969 L 2.941406 1.667969 C 2.273438 1.65625 1.726562 2.191406 1.714844 2.859375 L 1.714844 17.140625 C 1.726562 17.808594 2.273438 18.34375 2.941406 18.332031 L 17.058594 18.332031 C 17.726562 18.34375 18.273438 17.808594 18.285156 17.140625 L 18.285156 2.859375 C 18.273438 2.191406 17.726562 1.65625 17.058594 1.667969 Z M 6.742188 15.617188 L 4.242188 15.617188 L 4.242188 8.117188 L 6.742188 8.117188 Z M 5.492188 7.066406 C 4.773438 7.066406 4.191406 6.484375 4.191406 5.765625 C 4.191406 5.046875 4.773438 4.464844 5.492188 4.464844 C 5.992188 4.410156 6.480469 4.644531 6.746094 5.070312 C 7.015625 5.496094 7.015625 6.039062 6.746094 6.464844 C 6.480469 6.890625 5.992188 7.125 5.492188 7.066406 Z M 15.757812 15.617188 L 13.257812 15.617188 L 13.257812 11.589844 C 13.257812 10.582031 12.898438 9.925781 11.992188 9.925781 C 11.414062 9.929688 10.902344 10.292969 10.707031 10.832031 C 10.644531 11.027344 10.613281 11.234375 10.625 11.441406 L 10.625 15.609375 L 8.125 15.609375 C 8.125 15.609375 8.125 8.792969 8.125 8.109375 L 10.625 8.109375 L 10.625 9.167969 C 11.085938 8.363281 11.957031 7.882812 12.882812 7.917969 C 14.550781 7.917969 15.757812 8.992188 15.757812 11.300781 Z M 15.757812 15.617188 "
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "LinkedIn"
};
</script>
